import { render, staticRenderFns } from "./HelpSystem.vue?vue&type=template&id=67f9db61"
import script from "./HelpSystem.vue?vue&type=script&lang=js"
export * from "./HelpSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports